import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IButtonTemplateModel } from '../button-template-vm';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-template-button-row',
  templateUrl: './button-row.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, NgClass, MatProgressSpinner],
})
export class ButtonRowComponent {
  @Input() public tab: { data: IButtonTemplateModel | null; loading: boolean | null; templateTitle: string | null };
}
